import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import MainLayout from "../../../component/atoms/layout/mainLayout";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import TextFormEditor from "./../../../component/atoms/input/textFormEditor";
import BasicBtn from "./../../../component/atoms/button/basicBtn";

import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";
import BoardApi from "../../../api/board.api";
import { route } from "../../../router/route";
import scrollToTop from "../../../util/scrollToTop";

const WritingCrewGuideCreate = () => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [content, setContent] = useState();

  // ---------- 라이팅크루지도 생성 ---------- //
  const createGuide = async () => {
    try {
      const data = {
        title: "멤버십 가이드",
        content: content,
        boardPostType: "CREW_GUIDE",
      };
      await BoardApi.createBoard(data);

      navigate(route.crew_guide, { replace: true });
      scrollToTop();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>멤버십 가이드</TableTitle>
          <TextFormEditor
            placeholder={"상세 내용을 입력해주세요"}
            value={content}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            onChange={(e) => {
              setContent(e);
            }}
            editorHeight={600}
            style={{
              width: "100%",
            }}
          />
          <div
            style={{
              width: "100%",
              height: 79,
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              gap: 12,
            }}
          >
            {/* <BasicBtn isBlue={true} onClick={() => {}}>
              미리보기
            </BasicBtn> */}
            <BasicBtn
              onClick={() => {
                createGuide();
              }}
            >
              업로드하기
            </BasicBtn>
          </div>
        </DetailPageLayout>
      </MainLayout>
    </>
  );
};

export default WritingCrewGuideCreate;
